define('core/utils/browser',[
], function (
) {
    'use strict';

    var exports = {
        isIE: function () {
            // http://msdn.microsoft.com/en-us/library/dn321432.aspx
            // http://msdn.microsoft.com/en-us/library/cc196988(v=vs.85).aspx
            return Boolean(window.document.documentMode);
        },

        isSafari: function () {
            // http://stackoverflow.com/questions/7944460/detect-safari-browser
            var ua = window.navigator.userAgent.toLowerCase();
            return ua.indexOf('safari') > -1 && ua.indexOf('chrome') === -1;
        },

        isFirefox: function () {
            // https://stackoverflow.com/questions/7000190/detect-all-firefox-versions-in-js
            var ua = window.navigator.userAgent.toLowerCase();
            return ua.indexOf('firefox') > -1 && ua.indexOf('chrome') === -1;
        },

        isChrome: function () {
            // https://stackoverflow.com/questions/4565112/javascript-how-to-find-out-if-the-user-browser-is-chrome/13348618#13348618
            var ua = window.navigator.userAgent.toLowerCase();
            return ua.indexOf('crios') > -1 /* chrome ios */ ||
                (Boolean(window.chrome) /* chromium based */ &&
                    window.navigator.vendor === 'Google Inc.' /* from google */ &&
                    window.opr === undefined /* not opera */ &&
                    ua.indexOf('edge') === -1 /* not edge */);
        },

        isEdge: function () {
            var ua = window.navigator.userAgent.toLowerCase();
            return ua.indexOf('edge') > -1;
        },

        isOpera: function () {
            // https://stackoverflow.com/questions/1998293/how-to-determine-the-opera-browser-using-javascript
            var ua = window.navigator.userAgent.toLowerCase();
            return ua.indexOf('opera') > -1 || ua.indexOf('opr') > -1;
        },

        isCrawler: function (win) {
            // This logic MUST match the `is_crawler` check in rDISQUS as the
            // backend will return a different lounge response based on this.

            if (win === undefined)
                win = window;

            var ua = win.navigator.userAgent;
            return /bot|crawl|slurp|spider|facebookexternalhit|embedly|feedly|pinterest/i.test(ua);
        },
    };

    return exports;
});

